import { api } from './axios';
import { TENANT, ACCESS_TOKEN, CHATBOT_SESSION_ID } from '../constants/localstorage';

// Generate a unique session ID
export const generateSessionId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

// Store session ID in localStorage to persist across page reloads
export const getSessionId = () => {
  let sessionId = localStorage.getItem(CHATBOT_SESSION_ID);
  if (!sessionId) {
    sessionId = generateSessionId();
    localStorage.setItem(CHATBOT_SESSION_ID, sessionId);
  }
  return sessionId;
};

// Create a new session ID and store it in localStorage
export const createNewSession = () => {
  const newSessionId = generateSessionId();
  localStorage.setItem(CHATBOT_SESSION_ID, newSessionId);
  return newSessionId;
};

export const sendMessageToAgent = async (message, agentId = 'frontendAgent', context = {}) => {
  const sessionId = getSessionId();
  
  // Create the message object with context
  const messageObject = {
    userMessage: message,
    context: {
      cartId: context.cartId || null,
      siteId: context.siteId || null,
      currency: context.currency || null,
      language: context.language || null
    }
  };

  const { data } = await api.post(`/ai-service/{tenant}/agentic/chat`, {
    agentId: agentId,
    message: JSON.stringify(messageObject)
  }, {
    headers: {
      'session-id': sessionId
    }
  });

  return data;
};

export const AVAILABLE_AGENTS = {
  ORDER_CHECKER: 'frontendAgent',
  B2B_ONBOARDING: 'b2b-onboarding',
};
